import EkomApi from '../api/EkomApi'
import { useFetch } from './useFetch'

export const useCoutContractAll = (extObjectId: string) => {
  const incoming = useFetch<number>(() => EkomApi.getCountIncoming(extObjectId))
  const outgoing = useFetch<number>(() => EkomApi.getCountOutgoing(extObjectId))
  const submissions = useFetch<number>(() => EkomApi.getCountSubmissions(extObjectId))
  const unreadIncoming = useFetch<number>(() => EkomApi.getCountUnreadIncoming(extObjectId))
  const unreadOutgoing = useFetch<number>(() => EkomApi.getCountUnreadOutgoing(extObjectId))

  return {
    loading: incoming.loading || outgoing.loading || submissions.loading || unreadIncoming.loading || unreadOutgoing.loading,
    countIncoming: incoming.data || 0,
    countOutgoing: outgoing.data || 0,
    countSubmissions: submissions.data || 0,
    countUnreadIncoming: unreadIncoming.data,
    countUnreadOutgoing: unreadOutgoing.data,
  }
}
